module.exports = __webpack_public_path__ + "img/pret-okragly.d69753d3.jpg";